import { render, staticRenderFns } from "./UpdateModalTemplate.vue?vue&type=template&id=821ca144&"
import script from "./UpdateModalTemplate.vue?vue&type=script&lang=js&"
export * from "./UpdateModalTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports